<template>
  <div>
    <fin-data-loader :resolver="loadData">
      <div v-if="archetypeSelected && $vuetify.breakpoint.smAndUp" class="arche-type-spacer"/>

      <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                   fluid>
        <v-row v-if="!archetypeSelected">
          <v-col cols="8" md="7" lg="5" xl="5">
            <p class="numbered-title">Lege deine Ziele fest</p>
            <p class="psmall">
              Welcher Anlegertyp bist du? Und welche Ziele willst du mit deinem Investment erreichen?
            </p>
            <fin-tool-row-display routeToStart="finStrategy_profiler" v-if="$vuetify.breakpoint.mdAndUp"
                                  button-align="left"
                                  class="fin-profiler-row pa-2"
                                  description="Entdecke hier die Archetypen und wähle den, der am besten zu dir passt."
                                  name="finProfiler"/>
          </v-col>
          <v-col cols="4" md="5" lg="5" xl="5">
            <v-img :src="require('@/assets/finStrategy/fin-strategie.svg')"
                   style="z-index: 30"
                   v-style:heigth="$valueByBreakpoint({xs: '140px', sm: '140px', md: '288px', lg: '238px', xl: '288px'})"
                   v-style:marginBottom="$valueByBreakpoint({xs: '0px', sm: '0px', md: '0px', lg: '0px', xl: '0px'})"
                   v-style:marginLeft="$valueByBreakpoint({xs: '0px', sm: '20px', md: '0px', lg: '0px', xl: '0px'})"
                   v-style:marginTop="$valueByBreakpoint({xs: '-20px', sm: '-70px', md: '-100px', lg: '-90px', xl: '-120px'})"
                   v-style:maxWidth="$valueByBreakpoint({lg: '800px', xl: '800px'})"
                   v-style:width="$valueByBreakpoint({xs: '100px', sm: '140px', md: '289px', lg: '289px', xl: '289px'})"/>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.smAndDown">
            <fin-tool-row-display routeToStart="finStrategy_profiler"
                                  button-align="left"
                                  class="fin-profiler-row pa-2"
                                  description="Entdecke hier die Archetypen und wähle den, der am besten zu dir passt."
                                  name="finProfiler"/>

          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12" lg="7" md="7" xl="7">
            <div :class="'selectedArchetype ' + ($vuetify.breakpoint.xs ? 'pt-3 pb-0 pl-3 ' : 'pt-4 pl-8 mr-12')"
                 :style="$vuetify.breakpoint.xs ? 'margin-bottom: 25px' : 'margin-bottom: 52px'">
              <v-row>
                <v-col cols="7" sm="6">
                  <p class="archetype-name-intro mb-1">Du bist der Anlegertyp</p>
                  <p class="archetype-name mb-6">Der {{ profileArchetype.title }}</p>
                  <v-btn id="target-matrix-buttton" @click="archetypeChangeDialog = true" outlined>Zielmatrix bearbeiten
                  </v-btn>
                  <p class="lastModified mt-3 mb-0" v-if="profile.archetypeUpdatedAt">zuletzt bearbeitet:
                    {{ profile.archetypeUpdatedAt | datetime }}</p>
                </v-col>
                <v-col cols="5" sm="6">
                  <fin-archetype-illustration :archetype="profileArchetype"
                                              :height="$vuetify.breakpoint.xs ? 155 : 249"
                                              disable-centered-display
                                              animate
                                              hide-scene
                                              width="100%"
                                              style="margin-top: 0;"/>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" lg="5" md="5" xl="5">
            <fin-tool-row-display :displayImg="false"
                                  button-align="left"
                                  description="Mit dem finProfiler kannst Du deinen Archetyp von neuem definieren."
                                  name="finProfiler"
                                  :class="$vuetify.breakpoint.xs ? 'mt-0 pa-2 fin-profiler-row' : 'mt-1 pa-2 fin-profiler-row'"
                                  routeToStart="finStrategy_profiler"/>
            <fin-tool-row-display :displayImg="false"
                                  button-align="left"
                                  description="Hier kannst du dir passend zu deinem Anlegertyp ein Portfolio erstellen."
                                  name="finStrategist"
                                  :check-if-route-is-allowed="checkIfStrategistIsAllowed"
                                  :route-not-allowed-action="strategistNotAllowedAction"
                                  id="fin-strategy-row"
                                  :class="$vuetify.breakpoint.xs ? 'mt-6 mb-2 pa-2' : 'mt-1 pa-2'"
                                  routeToStart="finStrategy_strategist"/>

          </v-col>
        </v-row>

        <fin-dialog :fullscreen="$vuetify.breakpoint.xs"
                    :max-width="900"
                    dense
                    content-class="archetype-selector-dialog"
                    v-model="archetypeChangeDialog">
          <fin-data-loader :resolver="sleep" fullpage>
            <template #content>
              <div class="fin-dialog-densecontent-x">
                <fin-archetype-individual
                  style="width: 100%"
                  :initial-classification="archetypeSelected ? profileArchetype.classification : null"
                  class="pb-0 mb-0" @change="val => newArchetype = val"/>
                <div class="triangle-down-gray"/>
              </div>

              <v-row
                class="fin-color-primary-dark fin-dialog-dense-x fin-dialog-dense-bottom"
                dense>
                <v-col class="px-0">
                  <v-card-actions
                    :style="'padding-top: 48px; padding-bottom: ' + ($vuetify.breakpoint.xs ? (48+56/2) : 48) + 'px'"
                    class="justify-center px-0">
                    <v-btn color="white"
                           light
                           @click="saveProfileArchetype">
                        <span class="pl-4 pr-4">
                          Speichern
                        </span>
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </template>
          </fin-data-loader>
        </fin-dialog>
      </v-container>
    </fin-data-loader>
  </div>
</template>

<script>
import FinToolRowDisplay from '@/components/pages/finStrategy/ToolRowDisplay'
import FinArchetypeIndividual
  from '@/components/pages/onboarding/Step2/ArchetypeDirect/ArchetypeSelector/ArchetypeIndividual'
import {mapActions, mapGetters} from "vuex"
import FinDataLoader from "@/components/common/DataLoader/index"
import FinArchetypeIllustration from "../onboarding/ArchetypeIllustration/index"
import {API, graphqlOperation} from "aws-amplify"
import PriceModel from "@/mixins/PriceModel"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import {EventBus} from "@/plugins/fincraft"

const listUserPortfolios = `
query listPortfoliosByOwner($owner : String!) {
  listPortfoliosByOwner(owner: $owner, sortDirection: DESC, inclInactive: true) {
   items {
      id
      name
      inactive
    }
  }
}
`

export default {
  name: 'FinGoals',
  components: {FinArchetypeIllustration, FinDataLoader, FinToolRowDisplay, FinArchetypeIndividual},
  mixins: [PriceModel],
  data() {
    return {
      archetypeChangeDialog: false,
      newArchetype: null,
      mobNavHeight: document.querySelector('.v-bottom-navigation')?.getBoundingClientRect().height | 0,
      currentNbOfPortfolios: null
    }
  },
  computed: {
    ...mapGetters('auth', ['profileArchetype', 'profile', 'userId']),
    archetypeSelected() {
      return !!this.profileArchetype
    }
  },
  methods: {
    ...mapActions('archetype', ['loadArchetypeClassifications', 'loadArchetypes']),
    ...mapActions('auth', ['updateArchetype']),
    sleep() {
      // add some delay so the matrix svg lines will get paint AFTER the dialog opening animation
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 300)
      })
    },
    saveProfileArchetype() {
      this.updateArchetype(this.newArchetype.archeType.id)
      this.archetypeChangeDialog = false
    },

    strategistNotAllowedAction() {
      let newCount = this.currentNbOfPortfolios
      EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.PORTFOLIO.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUANTITY, {itemAmount: ++newCount})
    },
    checkIfStrategistIsAllowed() {
      return this.isPriceModelFeatureEnabled(PRICEMODEL_FEATURE_IDS.PORTFOLIO.id) &&
        this.currentNbOfPortfolios < this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.PORTFOLIO.id)
    },
    async loadData() {
      await API.graphql(graphqlOperation(listUserPortfolios, {
        owner: this.userId
      })).then(result => {
        this.currentNbOfPortfolios = result.data.listPortfoliosByOwner.items.length
      })
    }
  },
  mounted() {
    this.loadArchetypeClassifications()
    this.loadArchetypes()
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.arche-type-spacer {
  min-height: 50px;
  width: 100%;
  background-color: $fin-color-primary-dark;
}

.numbered-title {
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;

  @media only screen and (max-width: 600px) {
    font-size: 18px;
  }
}

.archetype-name-intro {
  font-size: 14px;
}

.archetype-name {
  font-family: $body-font-family;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;

  @media only screen and (max-width: 600px) {
    font-size: 18px;
  }

}

.edit-matrix {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: 0.4px;
  text-align: center;
  color: $fin-color-primary-dark;
  /* additional styling */
  text-decoration: none;
}

.selectedArchetype {
  background-color: $fin-color-primary-light;
  box-shadow: $fin-color-card-shadow;
  height: 188px;
  margin-top: -50px;

  @media only screen and (max-width: 600px) {
    margin-top: 8px
  }
}

p.lastModified {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #888999;
}

.triangle-down-gray {
  width: 0;
  height: 0;
  border-left: 25px solid transparent;
  border-right: 25px solid transparent;
  border-top: 50px solid #ededf1;
  position: absolute;
  clip-path: polygon(50% 35%, 0 0, 100% 0);
  left: 50%;
  margin-left: -25px;
  margin-top: -1px;
}

.ie .triangle-down {
  border-top: 20px solid white !important;
  margin-top: -7px !important;
}

.ie .triangle-down-gray {
  border-top: 20px solid #ededf1 !important;
  margin-top: -7px !important;
}

.edge .triangle-down {
  border-top: 20px solid white !important;
}

.edge .triangle-down-gray {
  border-top: 20px solid #ededf1 !important;
}

::v-deep .archetype-selector-dialog {
  overflow-x: hidden !important;
  box-shadow: $fin-color-dialog-shadow;
}
</style>
